import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import Joyride from 'react-joyride';
import PageLoading from '../common/componentsV2/elements/PageLoading';
import {
  AvvisoAlert,
  RcQuotesStyles,
} from './RcQuotes.styles';
import LambdaLoaderCard from '../common/components/redesignComponents/ResultPageComponents/v2/LambdaLoaderCard';
import {
  loadMotoQuotes,
  toggleMotoCoveragesAction,
  updateMotoQuotesData,
  resetMotoQuotes,
  addQuoteMotoToCart,
  removeQuoteMotoFromCart,
  silentLoadMotoQuotes,
} from '../features/insuranceRequests/insuranceRequestsActions';
import { confirmAlert, generalAlertError } from '../common/utils/alerts';
import { EstimateContainer } from '../common/components/redesignComponents/common/Redesign.styles';
import GuaranteesMotoModal from '../common/components/redesignComponents/Modal/GuaranteesMotoModal';
import ErrorComponent from '../common/components/ErrorComponent';
// import { useTourContext } from '../context/useTourContext';
// import { joyrideOptions } from '../common/utils/joyrideUtils';
// import { handleCallbackRcMotoQuote } from '../common/utils/joyrideCallbacks';
// import { RcMotoQuoteSteps } from '../common/utils/joyrideSteps';
import { primaQuoteTypes } from '../common/constants';
import { V2FontImport } from '../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import MotoSummaryCard from '../common/components/redesignComponents/ResultPageComponents/v2/MotoSummaryCard';
import QuoteCostSummaryCard from '../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import {
  OutlineActionButton,
  ActionButtonBadge,
} from '../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';
import {
  RiskCard,
  RiskContainer,
} from '../common/components/redesignComponents/ResultPageComponents/v2/ResultSlotCard.styles';
// import AragCard from '../common/components/redesignComponents/Cards/AragCard';
import {
  riskCardPrimaStyles,
  riskCardStyles,
} from '../common/components/redesignComponents/ResultPageComponents/RcQuotesModal.style';
import SelectedQuotesCardsPrima from '../common/components/redesignComponents/ResultPageComponents/SelectedQuotesCardsPrima';
import ButtonComponentLogicPrima from '../common/components/redesignComponents/ResultPageComponents/ButtonComponentLogicPrima';
import ModalQuotesPrima from '../common/components/redesignComponents/ResultPageComponents/ModalQuotesPrima';
import ModalQuotesMoto from '../common/components/redesignComponents/ResultPageComponents/ModalQuotesMoto';
import SelectedQuotesCards from '../common/components/redesignComponents/ResultPageComponents/SelectedQuotesCards';
import ButtonComponentLogic from '../common/components/redesignComponents/ResultPageComponents/ButtonComponentLogic';
import quotationsAxe from '../services/axios-client/quotationsAxeClient';
import ConversationModal from '../common/components/redesignComponents/Modal/ConversationModal';
import FailedQuotationsComponent from '../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

function RcMotoQuotes() {
  const navigate = useNavigate();
  const { requestToken } = useParams();
  const [showGuaranteesModal, setShowGuaranteesModal] = useState(false);
  const [showConversationModal, setShowConversationModal] = useState(false);
  const clearQuotesIntervalRef = useRef(null);
  const requestInfoRef = useRef(null);
  const [intervalQuotes, setIntervalQuotes] = useState(null);
  const state = useSelector((store) => store.insuranceRequests.moto_quotes);
  const {
    loading,
    requestInfo,
    failedQuotes,
    coverages,
    error,
    quotations,
    processingQuote,
    tutelaLegaleQuote,
    addingQuote,
    risk_quotations,
    thread,
    est_provvigioni,
  } = state;
  const checkResultsIntervalRef = useRef(null);
  const isPollingStartedRef = useRef(false);
  const [allScrapperResulsGotten, setAllScrapperResulsGotten] = useState({
    genial_received: false,
    // linear_received: false,
    facile_received: false,
  });
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  // const [showSellingDistanceModal, setShowSellingDistanceModal] = useState(false);
  const [counter, setCounter] = useState(180);
  // const [currentQuotes, setCurrentQuotes] = useState('diretta');
  // ? diretta = Greenia Companies
  // ? indiretta = Preventivass Companies
  // ? quotazioni = All Preventivass Quotes

  // const handleCurrentQuotesDisplay = (val) => {
  //   setCurrentQuotes(val);
  // };

  // const [steps, setSteps] = useState([]);
  const guaranteesPrima = (quote) => {
    const guarantees = quote.quotation_data_prima_guarantees
      .map((guarantee) => guarantee.slug)
      .filter((g) => g != 'rca' && g != 'furto_incendio');
    if (
      quote.quotation_data_prima_guarantees.find(
        (qg) => qg.slug == 'furto_incendio',
      ) != undefined
    ) {
      guarantees.push('incendio');
      guarantees.push('furto');
    }
    return guarantees;
  };

  const refresh = () => loadMotoQuotes(requestToken);
  const silentRefresh = () => silentLoadMotoQuotes(requestToken);

  const updateCoverages = (item) => {
    toggleMotoCoveragesAction(item.id);
  };

  const includesCoverage = (key) => coverages !== null && coverages.includes(key);

  const checkScrapperResponses = async () => {
    const response = await quotationsAxe.get(`/quotations/check-quote-results-moto/${requestInfo.id}`);
    if (response.status !== 200) {
      console.log('Failed to check quotation results response!');
      return false;
    }

    setAllScrapperResulsGotten({
      genial_received: response.data.genial_received,
      // linear_received: response.data.linear_received,
      facile_received: response.data.facile_received,
    });
    if (
      response.data.genial_received === true
      // || response.data.linear_received === true
      || response.data.facile_received === true
    ) {
      silentRefresh();
    }
    return response.data.received_all;
  };

  // const getSellingDistanceLink = () => `${SELLING_DISTANCE_URL}/request/${requestInfo.distance_token}/motorcycle/results`;

  // const copySellingDistanceLink = async () => {
  //   try {
  //     const link = getSellingDistanceLink();

  //     await navigator.clipboard.writeText(link);
  //     generalAlertSuccess('Il collegamento e stato copiato');
  //   } catch (err) {
  //     // console.log(err);
  //   }
  // };

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('newResultMoto') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('newResultMoto')]);

  // const firePurchaseTour = () => {
  //   localStorage.removeItem('newResultMoto');
  //   setState({ run: true });
  // };

  useEffect(() => {
    loadMotoQuotes(requestToken);

    return () => {
      resetMotoQuotes();
    };
  }, []);

  const clearQuotesInterval = () => {
    if (intervalQuotes !== null) {
      clearInterval(intervalQuotes);
      setIntervalQuotes(null);
    }
  };

  clearQuotesIntervalRef.current = clearQuotesInterval;
  requestInfoRef.current = requestInfo;

  useEffect(() => {
    const iq = setInterval(() => {
      const requestInfo = requestInfoRef.current;
      if (requestInfo !== null && requestInfo.product_id == 1) {
        if (requestInfo.with_preventivas === null) {
          loadMotoQuotes(requestToken);
        }

        if (requestInfo.with_preventivas !== null) {
          clearQuotesIntervalRef.current();
        }
      }
    }, 10000);

    setIntervalQuotes(iq);

    return () => {
      clearQuotesIntervalRef.current();
    };
  }, []);

  useEffect(() => {
    if (!requestInfo?.id) return undefined;

    // Renewals already carry all company quotations — no scrapers are called, so skip polling.
    if (requestInfo.is_renewal) return undefined;

    // Reset polling flag when request ID changes (new request)
    isPollingStartedRef.current = false;

    // Clear any existing interval
    if (checkResultsIntervalRef.current) {
      clearInterval(checkResultsIntervalRef.current);
      checkResultsIntervalRef.current = null;
    }

    // Check scrapper responses once and start polling if needed
    const initializePolling = async () => {
      const allReceived = await checkScrapperResponses();

      // Start interval only if not already polling and not all results received
      if (!isPollingStartedRef.current && !allReceived) {
        isPollingStartedRef.current = true;

        checkResultsIntervalRef.current = setInterval(async () => {
          const allReceivedInInterval = await checkScrapperResponses();
          if (allReceivedInInterval && checkResultsIntervalRef.current) {
            clearInterval(checkResultsIntervalRef.current);
            checkResultsIntervalRef.current = null;
            isPollingStartedRef.current = false;
          }
        }, 5000);
      }
    };

    initializePolling();

    return () => {
      if (checkResultsIntervalRef.current) {
        clearInterval(checkResultsIntervalRef.current);
        checkResultsIntervalRef.current = null;
        isPollingStartedRef.current = false;
      }
    };
  }, [requestInfo?.id, requestInfo?.is_renewal]);

  useEffect(() => {
    if (requestInfo !== null && requestInfo.quotations) {
      updateMotoQuotesData(requestInfo);
    }
  }, [requestInfo]);

  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const modifyData = () => {
    navigate('/quote/motorcycle', {
      state: { requestToken },
    });
  };

  // const leadSourceName = {
  //   0: 'Intermediario',
  //   1: 'Sito publico',
  // };

  // useEffect(() => {
  //   if (requestInfo && requestInfo.is_expired === true && requestInfo.request_token === requestToken) {
  //     navigate('/quote/motorcycle', {
  //       state: { requestToken },
  //     });
  //     generalAlertError(
  //       'È necessario compilare nuovamente il preventivo!',
  //       'Link e scaduto!',
  //     );
  //   }
  // }, [requestInfo, requestToken]);

  const fetchQuotes = () => {
    loadMotoQuotes(requestToken);
  };

  const selectQuotation = (quoteId) => {
    const quote = requestInfo ? requestInfo?.quotations?.find((q) => q.id === quoteId) : null;
    if (
      quote
      && quote.payment_frequency != requestInfo.payment_frequency
      && quote.quote_type === 'res_civile'
    ) {
      confirmAlert(
        `La frequenza di pagamento di questa quotazione è ${quote.payment_frequency == 1 ? 'annuale' : 'semestrale'}, mentre la frequenza di pagamento selezionata nella richiesta è ${requestInfo.payment_frequency == 1 ? 'annuale' : 'semestrale'}. Sei sicuro di voler aggiungere questa quotazione al carrello? Questo aggiornerà anche la frequenza di pagamento della richiesta.`,
        () => addQuoteMotoToCart(quoteId, fetchQuotes, modifyData),
      );
    } else {
      confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addQuoteMotoToCart(quoteId, fetchQuotes, modifyData));
    }
  };

  const handleRequestSave = () => {
    if (processingQuote === null) {
      generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
      return;
    }

    navigate(`/quotes/moto/purchase/${requestToken}`);
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeQuoteMotoFromCart(quoteId, fetchQuotes, modifyData));
  };

  // useEffect(() => {
  //   RcMotoQuoteSteps(quotations, setSteps);
  // }, [quotations]);

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let tutelaInProccessAmount = 0;
    let primaGuaranteesPrices = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (risk_quotations && risk_quotations[type.id] !== undefined) {
        for (let i = 0; i < risk_quotations[type.id].length; i++) {
          const item = risk_quotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    // if (processingQuote !== null) {
    //   if (processingQuote.company_id === 2) {
    //     quoteInProccessAmount = processingQuote.quotation_data_prima?.quotation_data_prima_guarantees ? parseFloat(
    //       processingQuote.quotation_data_prima?.quotation_data_prima_guarantees.find(
    //         (price) => price.slug === 'rca',
    //       ).quotation_data_prima_guarantee_prices[0].discounted_to_display,
    //     ) : parseFloat(processingQuote.amount);
    //   } else {
    //     quoteInProccessAmount = parseFloat(processingQuote.amount);
    //   }
    // }

    if (tutelaLegaleQuote !== null) {
      tutelaInProccessAmount = parseFloat(tutelaLegaleQuote.amount);
    }

    if (processingQuote.company_id === 2) {
      processingQuote.guarantees.forEach((guarantee) => {
        primaGuaranteesPrices += parseFloat(guarantee.amount) || 0;
      });
    }

    return (
      quoteInProccessAmount
      + tutelaInProccessAmount
      + primaGuaranteesPrices
      + risksTotalAmount
    ).toFixed(2);
  };

  if (loading) {
    return <PageLoading />;
  }

  return error !== null ? (
    <ErrorComponent error={error} />
  ) : (
    <>
      {/* <Joyride
            steps={steps}
            run={run}
            continuous
            showBeacon={showBeacon}
            locale={{
              back: 'Indietro',
              close: 'Chiudi',
              last: 'Fine',
              next: 'Prossima',
              open: 'Apri il modale',
              restart: 'Riavvia il tour ',
              skip: 'Salta',
            }}
            styles={{
              options: joyrideOptions,
              buttonNext: {
                backgroundColor: '#00a651',
                outline: 'none',
              },
              buttonBack: {
                color: '#00a651',
                outline: 'none',
              },
              beaconInner: {
                backgroundColor: '#00a651',
              },
              beaconOuter: {
                borderColor: '#00a651',
                backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
              },
              buttonSkip: {
                outline: 'none',
              },
              buttonClose: {
                outline: 'none',
              },
            }}
            callback={(data) => handleCallbackRcMotoQuote(data, steps, setState)}
            showSkipButton
            showProgress
          /> */}
      {showGuaranteesModal && (
        <GuaranteesMotoModal
          setShowGuaranteesModal={setShowGuaranteesModal}
          includesCoverage={includesCoverage}
          updateCoverages={updateCoverages}
          coverages={coverages}
          requestToken={requestToken}
        />
      )}

      {showConversationModal && (
        <ConversationModal
          requestId={requestInfo?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_moto_result"
        />
      )}

      <V2FontImport />
      <RcQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <MotoSummaryCard
              insuranceRequest={requestInfo}
              modificaDati={modifyData}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={risk_quotations}
              primaQuoteTypes={primaQuoteTypes}
              getTotal={getTotal}
              onProcedi={() => handleRequestSave()}
              est_provvigioni={est_provvigioni}
            />
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end">
                  <div>
                    <OutlineActionButton
                      type="button"
                      onClick={() => {
                        setShowConversationModal(true);
                        if (thread?.unreadMessages > 0) silentRefresh();
                      }}
                    >
                      <ChatIcon />
                      Contatta il Backoffice
                      {thread?.unreadMessages > 0 && (
                        <ActionButtonBadge>
                          {thread.unreadMessages}
                          <span className="visually-hidden">messaggi non letti</span>
                        </ActionButtonBadge>
                      )}
                    </OutlineActionButton>
                  </div>
                  {/* <div>
                        <h4>
                          Preventivi assicurazione
                          {' '}
                          <b>Moto</b>
                        </h4>
                        <p>
                          Inizio Copertura:
                          {' '}
                          {requestInfo.vehicle !== null
                            && new Date(
                              requestInfo.policy_effective_date,
                            ).toLocaleDateString('it-IT', {
                              year: 'numeric',
                              month: 'numeric',
                              day: 'numeric',
                            })}
                          <br />
                          Provenienza:
                          {' '}
                          {leadSourceName[requestInfo.lead_source]}
                        </p>
                      </div> */}

                  {/* <div>
                        {localStorage.getItem('newResultMoto') === 'done' && (
                          <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                            <button className="btn btn-success px-2 py-1">Tutorial</button>
                          </div>
                        )}
                      </div> */}
                </div>
              </EstimateContainer>
            </div>
          </div>

          {(allScrapperResulsGotten.facile_received === false && !requestInfo?.is_renewal) && (
            <div className="row my-3">
              <div className="col-12">
                <LambdaLoaderCard />
              </div>
            </div>
          )}

          {quotations && !quotations.res_civile
            && (
              <AvvisoAlert role="alert">
                <h4>Avviso!</h4>
                <p>Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </AvvisoAlert>
            )}

          {quotations && quotations.res_civile
            && (
              <>
                <RiskContainer className="mb-4 ">
                  {processingQuote !== null && processingQuote.company_id === 2
                    ? [{ id: 'res_civile', name: 'Responsabilita Civile' }].map(
                      (type, index) => (
                        <React.Fragment key={index}>
                          {quotations && quotations[type.id] && (
                            <RiskCard
                              className={riskCardStyles(
                                requestInfo,
                                type,
                                risk_quotations,
                              )}
                            >
                              <div className="me-auto">
                                <h5>{type.name}</h5>
                              </div>
                              <SelectedQuotesCards
                                processingQuote={processingQuote}
                                type={type}
                                riskQuotations={risk_quotations}
                                refresh={refresh}
                                requestInfo={requestInfo}
                                guaranteesPrima={guaranteesPrima}
                              />
                              <ButtonComponentLogic
                                type={type}
                                requestInfo={requestInfo}
                                processingQuote={processingQuote}
                                removeItemFromCart={removeItemFromCart}
                                riskQuotations={risk_quotations}
                              />
                            </RiskCard>
                          )}
                        </React.Fragment>
                      ),
                    )
                    : quoteTypes.map((type, k) => {
                      if (type.id === 'rc_transportati_minori' && processingQuote?.company_id !== 9) {
                        return null;
                      }

                      return (
                        <React.Fragment key={k}>
                          {quotations && quotations[type.id] ? (
                            <RiskCard
                              className={riskCardStyles(
                                requestInfo,
                                type,
                                risk_quotations,
                              )}
                            >
                              <div className="me-auto">
                                <h5>{type.name}</h5>
                              </div>
                              <SelectedQuotesCards
                                processingQuote={processingQuote}
                                type={type}
                                refresh={refresh}
                                requestInfo={requestInfo}
                                riskQuotations={risk_quotations}
                                guaranteesPrima={guaranteesPrima}
                              />

                              <ButtonComponentLogic
                                type={type}
                                processingQuote={processingQuote}
                                removeItemFromCart={removeItemFromCart}
                                requestInfo={requestInfo}
                                riskQuotations={risk_quotations}
                              />
                            </RiskCard>
                          ) : null}
                        </React.Fragment>
                      );
                    })}
                  {processingQuote !== null && processingQuote.company_id === 2 && (
                    <>
                      {processingQuote?.quotation_data_prima?.quotation_data_prima_guarantees.map(
                        (quote) => (
                          <>
                            {quote.slug !== 'rca' && (
                              <RiskCard
                                className={riskCardPrimaStyles(
                                  primaQuoteTypes.find(
                                    (type) => type.id === quote.slug,
                                  ),
                                  processingQuote,
                                )}
                              >
                                <div className="me-auto">
                                  <h5>
                                    {
                                      primaQuoteTypes.find(
                                        (type) => type.id === quote.slug,
                                      ).name
                                    }
                                  </h5>
                                </div>
                                <SelectedQuotesCardsPrima
                                  processingQuote={processingQuote}
                                  type={primaQuoteTypes.find(
                                    (type) => type.id === quote.slug,
                                  )}
                                />

                                <ButtonComponentLogicPrima
                                  type={primaQuoteTypes.find(
                                    (type) => type.id === quote.slug,
                                  )}
                                  processingQuote={processingQuote}
                                  requestInfo={requestInfo}
                                />
                              </RiskCard>
                            )}
                          </>
                        ),
                      )}
                    </>
                  )}
                </RiskContainer>

                {quoteTypes.map((type, index) => (
                  <ModalQuotesMoto
                    refresh={refresh}
                    processingQuote={processingQuote}
                    key={index}
                    type={type}
                    addingQuote={addingQuote}
                    requestInfo={requestInfo}
                    quotations={quotations}
                    selectQuotation={selectQuotation}
                    guaranteesPrima={guaranteesPrima}
                    riskQuotes={risk_quotations}
                  />
                ))}

                {processingQuote !== null
                  && processingQuote.company_id === 2
                  && primaQuoteTypes.map((type, index) => (
                    <ModalQuotesPrima
                      processingQuote={processingQuote}
                      key={index}
                      type={type}
                      addingQuote={addingQuote}
                      requestInfo={requestInfo}
                      requestToken={requestToken}
                      guaranteesPrima={guaranteesPrima}
                    />
                  ))}
                {failedQuotes !== null && failedQuotes.length > 0 && (
                  <FailedQuotationsComponent failedQuotes={failedQuotes} />
                )}
              </>
            )}
        </div>
      </RcQuotesStyles>
    </>
  );
}

export default RcMotoQuotes;
